export var INVITE_FRIENDS_FEATURE_STATUS = {
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
  COMING_SOON: 'COMING_SOON'
};